import Spinner from "@core/components/ui/Spinner";
import { cn } from "@core/lib/utils";

interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {}
export const LoadingOverlay = ({ className, ...props }: LoadingOverlayProps) => {
  return <div
    className={cn("absolute inset-0 bg-black bg-opacity-15 flex items-center justify-center z-[1]", className)}
    {...props}
  >
    <Spinner />
  </div>
};
